import { Loading as QLoading } from 'quasar'
import MiraLoader from 'components/partials/mira/MiraLoader'

export const Loading = {
  show (params = {}) {
    QLoading.show(
      Object.assign(params, {
        spinner: MiraLoader
      })
    )
  },
  hide () {
    QLoading.hide()
  }
}
